"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.auditFieldsSchema = void 0;
var Joi = require('joi').extend(require('@joi/date'));
exports.auditFieldsSchema = Joi.object({
    recordCreatedTimestamp: Joi.date()
        .format('YYYY-MM-DD HH:mm:ss.SSSSSS')
        .required(),
    recordCreatedUserID: Joi.string()
        .guid({
        version: ['uuidv4'],
    })
        .required(),
    recordUpdatedTimestamp: Joi.date()
        .format('YYYY-MM-DD HH:mm:ss.SSSSSS')
        .required(),
    recordUpdatedUserID: Joi.string()
        .guid({
        version: ['uuidv4'],
    })
        .required(),
});
exports.default = { auditFieldsSchema: exports.auditFieldsSchema };
